export default function defaultState() {
  return {
    mainTitle: '',
    isSidebarShown: false,
    isRefreshTokenModalClosed: false,
  }
}
